
<!--<script src="../../../../packages/index.js"></script>-->
<template>

  <div style="height: 100%; overflow-y: auto">
    <!--//表单设计器页面，用于新增和编辑表单页面-->
    <!--<el-dialog :visible.sync="addVisible" :modal-append-to-body="false">-->
    <!--<div v-if="addVisible" style="background-color: white;">
            <avue-form-design ref="avueformdesign"
                              :options="options"
                              @submit="handleSubmit">

            </avue-form-design>
        </div>-->
    <!--</el-dialog>-->
    <!--<el-dialog :visible.sync="buttonDialog.dialogVisible" :modal-append-to-body="false" :title="buttonDialog.title
">
            <el-form>
                <el-form-item v-if="buttonDialog.info.length > 0" :label="buttonDialog.title" label-position="left" label-width="100px">
                    <div>{{buttonDialog.info}}</div>
                </el-form-item>
                <el-form-item :label="buttonDialog.label" label-position="left" label-width="100px">
                    <el-input type="textarea" v-model="buttonDialog.reason" :placeholder="buttonDialog.label"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose()" >取消{{buttonDialog.title}}</el-button>
                    <el-button type="primary" @click="handleTerminate()">确认{{buttonDialog.title}}</el-button>
                </span>
        </el-dialog>

        &lt;!&ndash;表单页面，用于展示&ndash;&gt;
        &lt;!&ndash;<el-dialog :visible.sync="formvisible"
                   :modal-append-to-body="false">&ndash;&gt;
        <el-dialog :visible.sync="stepVisible" :modal-append-to-body="false" title="审批详情">
            <div >
                <el-timeline>
                    <el-timeline-item
                            v-for="(activity, index) in stepInfo"
                            :key="index"
                            :timestamp="activity.startTime"
                            :type="activity.type"
                            :size="activity.size"
                            placement="top">
                        {{activity.taskName}}

                        <p v-for="(citem, cindex) in activity.content" :key="cindex">{{citem}}</p>

                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>
        <div v-if="formvisible" style="height: 520px; background-color: white; padding-top: 10px">
            <div class="button-top">
                <el-button v-if="authButtonDisplay.addTask.display" @click="addTask" type="primary">加签</el-button>
                <el-button v-if="authButtonDisplay.deleteTask.display" @click="deleteTask" type="primary">减签</el-button>
                <el-button v-if="authButtonDisplay.termination.display" @click="terminateTask" type="primary">终止</el-button>
                <el-button v-if="authButtonDisplay.revokePreTask.display" @click="revokePreTask" type="primary">撤回</el-button>
                <el-button size="medium"
                           type="primary"
                           @click="getAuditDetail">查看审批详情</el-button>
               <el-button size="medium"
                           type="danger"
                           @click="handleBeforeClose">返回</el-button>
            </div>
            <div class="drawer-top">
                <h1>{{options.tableComment}}</h1>
                &lt;!&ndash;<div class="button-top">
                    <el-button @click="">保存</el-button>
                    <el-button @click="">保存并提交</el-button>
                </div>&ndash;&gt;
            </div>
            <avue-form
                    ref="avueform"
                    class="preview-form bold_input"
                    :option="options"
                    v-model="modeldata"
                    :upload-after="uploadAfter"
                    :upload-before="uploadBefore">

            </avue-form>
            &lt;!&ndash;<div class="drawer-foot">
                <el-button size="medium"
                           type="primary"
                           @click="handlePreviewSubmit">确定</el-button>
                <el-button size="medium"
                           type="danger"
                           @click="handleBeforeClose">取消</el-button>
            </div>&ndash;&gt;
        </div>
-->
    <avue-divider :column="column" style="display: none"></avue-divider>
    <view-form v-if="formvisible" :view-form-data="viewFormData" @formClose="formClose"></view-form>

    <dataTables v-if="tableVisible" ref="mainTable" :tableInfo="conf.mainTable" @mainTableReload="mainTableReload"
      @getForm="getForm" @batchAudit="batchAudit">
    </dataTables>
    <el-dialog :visible.sync="submitAgainVisible" :modal-append-to-body="false">

      <div>
        {{infoFromStartWorkflow}}
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取消提交</el-button>
        <el-button type="primary" @click="handleSubmitAgain()">确认提交</el-button>
      </span>
    </el-dialog>

    <confirm-dialog :config-info="confirmInfo" @handleSubmit="handleSubmit">

    </confirm-dialog>

  </div>
</template>

<script>
import dataTables from '../InternalComponent/easyCrud.vue'
import conf from './conf'
import { changeConfigToForm, modifyFormModelData, loadJs, uploadBefore, uploadAfter, downloadFileBeforePreview, setHeaderBeforeFileUpload, donwloadFileOnClick, changeFormModelUsingTaskForm } from "@/workFlow/utils/formUtil"
import { doValidBeforeAudit, batchAuditFunc } from "../util/auditUtil";
import { getToken } from '@/framework/util/auth'
import confirmDialog from '../InternalComponent/confirmDialog'
import { getButtonAuthority } from "../../flow/util/FlowUtil";
import viewForm from '@/workFlow/formComponent/viewForm/ViewForm.vue'

export default {
  data() {
    return {
      column: {
        dalign: 'center',
      },
      viewFormData: {
        options: {},
        modeldata: {},
        pageKey: '',
        row: {}
      },
      /*addVisible: false,*/
      formvisible: false,
      tableVisible: true,
      full: true,
      modeldata: {},
      options: {},
      conf,
      submitAgainVisible: false,
      infoFromStartWorkflow: '',
      postParams: {},
      isClassAudit: false,
      confirmInfo: {
        confirmVisible: false,
        options: {},
        modeldata: {}
      },
    }
  },

  components: { dataTables, confirmDialog, viewForm },

  mounted: function (params) {
    this.$nextTick(() => {
      this.mainTableReload(this.$refs.mainTable.getReloadConditions())
    })

  },

  methods: {
    formClose() {
      this.formvisible = false
      this.tableVisible = true
      this.$nextTick(() => {
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      })
    },


    handleClose() {
      this.submitAgainVisible = false
    },
    handleSubmitAgain() {
      this.submitAgainVisible = false
      this.postParams.dataMap.verifyFlag = "2"
      if (!this.isClassAudit) {
        this.$http.post('/wf-scholarship/batch-audit', this.postParams).then(response => {
          if (response.code === 200) {
            this.$message.info('成功执行')
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
          } else {
            this.$message.error(response.code + response.msg)
          }
        }).catch(error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
        })
      } else {
        this.$http.post('/batch-audit/do-task', this.postParams).then(response => {
          if (response.code === 200) {
            this.$message.info(response.msg)
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
          } else {
            this.$message.error(response.code + response.msg)
          }
        }).catch(error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
        })
      }

    },
    batchAudit() {
      let selectedRows = this.$refs.mainTable.getSelectedRows()
      if (!batchAuditFunc(this.conf, selectedRows, this.$message))
        return
      this.doAudit(selectedRows)

    },
    doAudit(rows) {
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].taskDefKey !== rows[0].taskDefKey) {
          this.$message.info("请选择相同环节审核")
          return
        }
      }
      if (rows[0].taskDefKey === 'XYSH') {//审核环节判断
        let postParams = {
          businessTaskList: [],
          dataMap: {
          },
          taskDefKey: "XYSH"
        }
        for (let i = 0; i < rows.length; i++) {
          postParams.businessTaskList.push(
            {
              businessKey: rows[i].id,
              taskId: rows[i].ruTaskId
              /*
              awardPrizeId: rows[i].awardPrizeId,
              awardYear: rows[i].awardYear,
              collegeId: rows[i].collegeId,
              classId: rows[i].classId
              */
            }
          )
        }
        this.postParams = postParams
        doValidBeforeAudit(this.$http, '/wf-scholarship/batch-valid', postParams, this.confirmInfo, this.$message)
        // this.doValidBeforeAudit_SU(postParams)
      } else if (rows[0].taskDefKey === 'XGCSH') {
        let postParams = {
          businessTaskList: [],
          dataMap: {},
          taskDefKey: "XGCSH"
        }
        for (let i = 0; i < rows.length; i++) {
          postParams.businessTaskList.push(
            {
              businessKey: rows[i].id,
              taskId: rows[i].ruTaskId,
              /* awardPrizeId: rows[i].awardPrizeId,
               awardYear: rows[i].awardYear,
               collegeId: rows[i].collegeId*/
            }
          )
        }
        this.postParams = postParams
        doValidBeforeAudit(this.$http, '/wf-scholarship/batch-valid', postParams, this.confirmInfo, this.$message)

        //this.doValidBeforeAudit_SU(postParams)

      } else if (rows[0].taskDefKey === 'BZRSH') {
        let postParams = {
          businessTaskList: [],
          dataMap: {}
        }
        for (let i = 0; i < rows.length; i++) {
          postParams.businessTaskList.push(
            {
              businessKey: rows[i].id,
              taskId: rows[i].ruTaskId
            }
          )
        }
        postParams.formId = rows[0].form_KEY_
        this.postParams = postParams
        doValidBeforeAudit(this.$http, '/batch-audit/valid', postParams.businessTaskList, this.confirmInfo, this.$message)
      } else {
        this.$message.info('不需要审核')
        return
      }
    },
    getForm(index, row) {
      row.businessKey = row.id
      console.log(row)
      this.$router.push({
        name: 'workFlow-view-myApply',
        params: {
          row: row,
          pageKey: 'VIEW'
        }
      })
      return
      console.log(row)
      if (row.taskName === '已完成') {
        this.$message.info('任务已完成')
        return
      }
      this.$http.get('/form-instance/select', { params: { 'dataId': row.id, 'formId': row.form_KEY_ } }).then(response => {
        if (response.code === 200) {
          this.modeldata = response.data
          this.$http.get('/form-model/detail', { params: { 'formId': row.form_KEY_ } }).then(response => {
            if (response.code === 200) {
              this.options = response.data.modelJson
              if (this.options.column && this.options.column.length > 0) {
                for (let i = 0; i < this.options.column.length; i++) {
                  this.options.column[i].disabled = true
                }
              }
              changeFormModelUsingTaskForm(this.options, [])
              loadJs(this.options)
              setTimeout(() => {
                this.viewFormData.options = this.options
                this.viewFormData.modeldata = this.modeldata
                this.viewFormData.pageKey = 'VIEW'
                this.viewFormData.row = row
                this.viewFormData.modeldata.processInstanceId = row.processInstanceId
                this.viewFormData.modeldata.taskId = row.taskId
                this.formvisible = true
                this.tableVisible = false
              }, 600)
            }
          })
        }
      })

    },
    handlePreviewSubmit() {
      console.log('fasdfasdf')
    },
    handleBeforeClose() {
      this.formvisible = false
      this.tableVisible = true
    },
    handleSubmit(formData) {
      console.log(this.confirmInfo.modeldata)
      for (let key in this.confirmInfo.modeldata) {
        if (key === 'BZRSH') {
          this.isClassAudit = true
        }
        this.postParams.dataMap[key] = this.confirmInfo.modeldata[key] + ""
      }
      console.log(this.postParams)
      this.postParams.dataMap.verifyFlag = "1"
      Object.assign(this.postParams.dataMap, formData)
      this.confirmInfo.confirmVisible = false
      if (this.isClassAudit) {//班主任审核环节
        this.$http.post('/batch-audit/do-task', this.postParams).then(response => {
          if (response.code === 200) {
            this.$message.info(response.msg)
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
          } else {
            this.$message.error(response.code + response.msg)
          }
        }).catch(err => {
          if (err.code === 1101) {
            this.submitAgainVisible = true
            this.infoFromStartWorkflow = err.msg
          } else {
            if (err.msg)
              this.$message.error(err.msg)
            else
              this.$message.error(err.message)
          }

        })
      } else {//学院和学工处审核
        this.$http.post('/wf-scholarship/batch-audit', this.postParams).then(response => {
          if (response.code === 200) {
            this.$message.info('成功执行')
          } else {
            this.$message.error(response.msg)
          }
        }).catch(err => {
          if (err.code === 1101) {
            this.submitAgainVisible = true
            this.infoFromStartWorkflow = err.msg
          } else {
            if (err.msg)
              this.$message.error(err.msg)
            else
              this.$message.error(err.message)
          }
        })
      }

    },
    /** 当主表需要重载的时候 */
    mainTableReload: function (params) {
      this.conf.mainTable.table.loading = true
      console.log(params)
      let JSONCon = {

      }
      console.log(this.$route.query.generalId)
      if (this.$route.query.generalId && this.$route.query.generalId.length > 0) {
        let querySplit = this.$route.query.generalId.split("=")
        if (querySplit[0] === 'classId') {
          JSONCon.classId = querySplit[1]
        } else {
          JSONCon.collegeId = querySplit[1]
        }


        for (let i = 0; i < this.conf.mainTable.table.columns.length; i++) {
          if (this.conf.mainTable.table.columns[i].prop === 'college') {
            this.conf.mainTable.table.columns[i].isSearchCondition = true
            break
          }
        }
      } else {
        for (let i = 0; i < this.conf.mainTable.table.columns.length; i++) {
          if (this.conf.mainTable.table.columns[i].prop === 'college') {
            this.conf.mainTable.table.columns[i].isSearchCondition = false
            break
          }
        }

        JSONCon.classId = params.class_
      }
      JSONCon.awardPrizeName = params.awardPrizeName,
        JSONCon.awardYear = params.awardYear
      JSONCon.taskDefKey = params.taskName
      this.$http.post('/wf-scholarship/query-scholarship?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize, JSONCon).then(
        response => {
          this.conf.mainTable.table.loading = false
          if (response.code === 200) {
            console.log(response.data)
            // 成功之后的数据


            if (!response.data.records)
              this.conf.mainTable.table.tableData = []
            else
              this.conf.mainTable.table.tableData = response.data.records
            this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
          this.$Log.capsule('分页加载模板错误', error, 'danger')
        }
      )

    },
    /*deleteRows: function(row){//删除操作
        var params = new URLSearchParams()
        params.append("formId", row[0].id)
        this.$http.post('/formModel/delete?formId='+row[0].id).then(res => {
            //this.conf.mainTable.loading = false
            if(res.code === 200){
                this.$message.success('删除表单成功！')
                this.mainTableReload(this.$refs.mainTable.getReloadConditions())
            } else {
                this.$message.error(res.code + res.msg)
            }
        }).catch(error => {
            this.$message.error("error" + error)
        })
    },
    saveRowByAddOrEdit: function (row, done, errorDone, optionType) {
        console.log(optionType)
    },
    beforeAddViewEdit: function name(row, optionType, call) {
        var op
        if(optionType === 'EDIT') {//编辑操作
            this.$http.get('/detail', {params: {formId: row.id}}).then(response => {
                if(response.code === 200){
                    this.options = response.data.modelJson
                    this.tableVisible = false
                    this.addVisible = true
                } else {
                    this.$message.error(response.code + response.msg)
                }

            }).catch(error => {
                this.$message.error("error" + error)
            })

        } else if (optionType === 'ADD'){//新增操作

            this.tableVisible = false
            this.addVisible = true
        } else {
            this.$http.get('http://192.168.17.28:8081/flowExt/todoTaskDescription', {params:{'businessKey': row.businessKey, 'taskId': row.taskId}}).then(response => {
                if(response.code === 200){
                    console.log("tototototdotototototototototototototot")
                    console.log(response)

                } else {
                    this.$message.error(response.code + response.msg)
                }
            }).catch(error => {
                this.$message.error("error" + error)
            })
        }

    }*/
  }
}
</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px;
  //display: flex;

  button {
    width: 50%;
  }
}

.drawer-top {
  position: relative;
  height: 60px;
  margin-top: 50px;
  text-align: center;
}
.button-top {
  text-align: right;
  position: absolute;
  top: 65px;
  right: 23px;
  display: flex;
  z-index: 90;
}

:deep(.preview-form) {
  padding-top: 10px;
  overflow-y: auto;
}
:deep(.avue-crud) {
  padding-bottom: 18px;
}
.bold_input :deep(.el-input__inner) {
  font-weight: bolder !important;
}
:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}
</style>
